<template>
  <v-dialog id="interrogate-component" fullscreen persistent v-model="interrogateDialog">
    <v-card color="rgba(0, 0, 0)" @click.native.prevent.stop="goForward">
      <v-container color="rgba(0, 0, 0)" pa-0>
        <v-img :src="getImage()" height="100%"></v-img>
      </v-container>
      <v-card-actions class="modal-actions">
        <v-btn flat @click.stop="goBack">
          <v-img :src="backButton"/>
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Store from "@/store";
import interrogateImage from "../../assets/backgrounds/interrogate.png";
import stopAndEatImage from "../../assets/backgrounds/stopandeat.png";

import backButton from "../../assets/directions/back_button.png";
export default {
  name: "interrogate-component",
  props: {
    step: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String
    }
  },
  mounted() {
    console.log("IN INTERROGATE COMPONENET", this.type, this.step);
  },
  data() {
    return {
      interrogateDialog: true,
      interrogateImage: interrogateImage,
      backButton: backButton
    };
  },
  methods: {
    clickInterrogate() {
      this.goForward();
    },
    getImage() {
      return this.type === "interrogate" ? interrogateImage : this.step.url.url;
    },
    closeAllDialogs() {
      this.answerDialog = false;
      this.incorrectDialog = false;
      this.correctDialog = false;
      this.helpDialog = false;
      this.hintDialog = false;
      this.giveUpDialog = false;
    },
    goBack() {
      this.closeAllDialogs();
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.closeAllDialogs();
      this.$store.dispatch("incrementStep");
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>
